import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { PropTypes } from 'prop-types';

import { ModalDisplayedTracker } from '@zenbusiness/application-commons-clickstream';
import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import AppBar from '@zenbusiness/zui/AppBar';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Dialog from '@zenbusiness/zui/Dialog';
import Text from '@zenbusiness/zui/Text';
import Toolbar from '@zenbusiness/zui/Toolbar';

export const EditProductModal = ({ productUuid, onClose, ...rest }) => {
  const { formatMessage } = useIntl();
  // TODO: load product/plan data

  return (
    <Dialog {...rest} fullScreen onClose={onClose}>
      <ModalDisplayedTracker
        elementName="checkout_edit_product"
        elementValue={productUuid}
        open={rest.open}
      />
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Text size="xl" sx={{ flex: 1, textAlign: 'center' }} weight="medium">
            <FormattedMessage id="shopping.page.checkout.edit" />
          </Text>
          <Button
            aria-label={formatMessage({ id: 'shopping.page.checkout.close' })}
            data-testid={`checkout-edit-product-${productUuid}`}
            icon={<CloseRoundedIcon />}
            iconPosition="end"
            variant="text"
            onClick={onClose}
          >
            <FormattedMessage id="shopping.page.checkout.cancel" />
          </Button>
        </Toolbar>
      </AppBar>
      <Box p={2}>
        <Text size="sm">Product UUID: {productUuid}</Text>
      </Box>
    </Dialog>
  );
};

EditProductModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  productUuid: PropTypes.string
};
